<template>
  <QRadio
    :class="[
      'sai-radio',
      textColorClass,
      { 'sai-radio--vertical-align': verticalAlign }
    ]"
    v-on="$listeners"
    v-bind="$attrs"
    :size="size"
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </QRadio>
</template>

<script>
import { QRadio } from 'quasar';

export default {
  name: 'SAIRadio',
  props: {
    size: {
      default: 'md'
    },
    textColor: {
      type: String
    },
    verticalAlign: Boolean
  },
  computed: {
    textColorClass() {
      return this.textColor ? `text-${this.textColor}` : '';
    }
  },
  components: { QRadio }
};
</script>

<style lang="sass" scoped>
.sai-radio::v-deep
  .q-radio__label
    margin-left: 2px

  svg
    border-radius: 50%
    border: 1px solid $grey-4

    *
      display: none

  .q-radio__inner--truthy
    svg
      border: 5px solid currentColor

  &.sai-radio--vertical-align
    &.q-radio
      align-items: start
</style>
